module.exports = __webpack_public_path__ + "media/images/alacartImage2-e28cf902.png";